var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClipboard = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 22V6h16v7.543C22 17.65 16 16 16 16s1.518 6-2.638 6zm18-7.614V4H4v20h10.189C17.352 24 24 16.777 24 14.386M14 16H9v-1h5zm5-4H9v1h10zm0-3H9v1h10zm2-7H2v19H0V0h21z"
})));
export { SvgClipboard as ReactComponent };
export default __webpack_public_path__ + "assets/images/clipboard.svg";